<div class="item_ico" *ngIf="showWarning" (click)="showAlert()">
  <div class="pgn_circle"></div>
  <div class="content_circle">
    <div class="alert">
      <div class="pgn_thumbnail">
        <div class="content_ico">
          <i class="fas fa-comment-slash" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
  <div :class="pgn_circle_rigth"></div>
</div>
<app-mu-modal-dialog-layout
  [flagList]="flags"
  [showFlag]="chatFlags.SHOW_WARNING"
  [icon]="'fa-exclamation-triangle'"
  [title]="'shared.chatFailureTitle' | translate"
  [showCloseIcon]="true"
>
  <p modalDialogContent class="p-col-12 mu-without-padding domain-warning-text" [innerHTML]="'shared.chatFailureMessage' | translate"></p>
  <div modalDialogContent class="chat-domains">
    <div class="chat-domain">wchat.freshchat.com</div>
    <div class="chat-domain">assetscdn-wchat.freshchat.com</div>
  </div>
</app-mu-modal-dialog-layout>
